import { render, staticRenderFns } from "./LocationPlace.vue?vue&type=template&id=2b96fd91&"
import script from "./LocationPlace.vue?vue&type=script&lang=js&"
export * from "./LocationPlace.vue?vue&type=script&lang=js&"
import style0 from "./LocationPlace.vue?vue&type=style&index=0&id=2b96fd91&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b96fd91')) {
      api.createRecord('2b96fd91', component.options)
    } else {
      api.reload('2b96fd91', component.options)
    }
    module.hot.accept("./LocationPlace.vue?vue&type=template&id=2b96fd91&", function () {
      api.rerender('2b96fd91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/LocationPlace.vue"
export default component.exports